import { getCompanyList } from "./configs/getCompanyList";
import { getLandData } from "./configs/getLandData";
import { getProjects } from "./configs/getProjects";
import { areaInfo } from "./configs/areaInfo";
import { engineer } from "./configs/engineer";

export const menuMap = {
  [getCompanyList.key]: getCompanyList.config,
  [getLandData.key]: getLandData.config,
  [getProjects.key]: getProjects.config,
  [areaInfo.key]: areaInfo.config,
  [engineer.key]: engineer.config,
} as any;
